import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as productsActions from './related-actions';
import * as routerSelectors from '../../../route/router-state.selectors';
import * as locationSelectors from '../../../locations/state/locations-selectors';
import * as searchSelectors from '../product-search/search-selectors';
import * as categorySelectors from '../../../categories/state/category/categories-selectors';
import * as categoryActions from '../../../categories/state/category/categories-actions';
import * as categoryTreeActions from '../../../categories/state/category-tree/category-tree-actions';

import { ProductService } from "../../_services/product.service";
import { catchError, exhaustMap, map, mergeMap, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { of } from "rxjs";
import { Store } from "@ngrx/store";
import { _seoContent } from "@app/marketplace/seo-content/utils";

@Injectable()
export class RelatedProductsEffects {
  constructor(private actions$: Actions, private service: ProductService, private store: Store<any>,) { }

    loadRelatedProducts$ = createEffect(() =>
      this.actions$.pipe(
        ofType(productsActions.LOADING_RELATED_PRODUCTS, productsActions.CANCEL_RELATED_PRODUCTS_REQUEST),
          withLatestFrom(
          this.store.select(routerSelectors.getMergedRoute),
          (action: any, router: any) => {
            return {action, payload: action.payload,}
          }
        ),
        switchMap((data: any) => {
          return this.service.GetRelatedProducts(data.payload).pipe(
            takeUntil(
              this.actions$.pipe(ofType(productsActions.CANCEL_RELATED_PRODUCTS_REQUEST))
            ),
            map((response: any) => {
              return { type: productsActions.LIST_RELATED_PRODUCTS, data:response?.data};
            }),
            catchError((error) => {
               return of({ type: productsActions.ERROR_RELATED_PRODUCTS })
              }
            )
          );
        })
      )
    );

    private getCategoryCode(sectionId: string) {
      return  _seoContent.map(x => ({code: x.categoryCode, name: x.sectionId})).find(x => x.name == sectionId)?.code;
    }
}


